import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import firebase from "firebase/app";
import AuthProvider from './Components/Admin/AuthProvider';


const firebaseConfig = {
  apiKey: "AIzaSyDjsoqc7sTBMVh_5Z6toatBNwCJmi3B-FE",
  authDomain: "mdi-konferencija2021.firebaseapp.com",
  databaseURL: "https://mdi-konferencija2021-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mdi-konferencija2021",
  storageBucket: "mdi-konferencija2021.appspot.com",
  messagingSenderId: "676062576242",
  appId: "1:676062576242:web:f3d15287c46974cf064ceb",
  measurementId: "G-H5CL5D7NTL"
};
firebase.initializeApp(firebaseConfig);
firebase.auth()
ReactDOM.render(
  
  <React.StrictMode>
    <AuthProvider>
    <App />
    </AuthProvider>
   
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
